import React from "react";
import logo from "../assets/images/logo2.svg";

const Navbar = () => {
  return (
    <header
      style={{
        position: "sticky",
        top: 0,
        zIndex: 999,
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: "12px 0",
        marginBottom: "20px", // ⭐ Added spacing under navbar
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: "6px",
          width: "100%",
        }}
      >
        {/* Logo */}
        <img
          src={logo}
          alt="Apex Remodeling Logo"
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            objectFit: "cover",
          }}
        />

        {/* Title */}
        <h2
          style={{
            margin: 0,
            fontSize: "22px",
            fontWeight: "700",
            color: "#222",
          }}
        >
          Apex Carpet, Tile & Remodeling
        </h2>

        {/* Tagline */}
        <p
          style={{
            margin: 0,
            fontSize: "14px",
            color: "#555",
          }}
        >
          Quality Work. Honest Pricing. Stunning Results.
        </p>

        {/* CTA Button */}
        <a
          href="tel:+1-281-550-6300"
          style={{
            marginTop: "6px",
            backgroundColor: "#007bff",
            color: "#fff",
            padding: "8px 18px",
            borderRadius: "30px",
            fontWeight: "600",
            fontSize: "14px",
            textDecoration: "none",
          }}
        >
          Get Free Quote
        </a>
      </div>
    </header>
  );
};

export default Navbar;
